import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fullUpdate, updateMailTemplates } from '@store/slice/mailTemplatesSlice'
import { updateNotification } from '@store/slice/mainSlice'
import { get } from '@util/xhrAPI'
import { useTranslation } from 'react-i18next'
import useDeleteButton from '@hook/useDeleteButton'
import useDynamicForm from '@hook/useDynamicForm'
import { useTheme } from '@table-library/react-table-library/theme'
import { getTheme } from '@table-library/react-table-library/baseline'
import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell,
} from "@table-library/react-table-library/table"
import Alert from '@ui/elements/Alert'
import Div from '@ui/layout/Div'
import Buttons from '@ui/elements/Buttons'

const ListMailTemplates = () => {
  const { mailTemplates } = useSelector(state => state.mailTemplates)
  const { mission } = useSelector(state => state.main)
  const theme = useTheme(getTheme())
  const dispatch = useDispatch()
  const deleteButton = useDeleteButton()
  const toggleDynamicForm = useDynamicForm()
  const [t] = useTranslation('common')

  const dataMailTemplates = { nodes: [] }
  if (mailTemplates) {
    dataMailTemplates.nodes = Object.values(mailTemplates)
  }

  const removeTemplate = template => {
    const { id, links } = template
    get(`${import.meta.env.VITE_API_URL}${links.remove}`, response => {
      const { code } = response
      if (code == 200) {
        const mailTemplate = mailTemplates[id]
        const mailTemplatesList = { ...mailTemplates }
        delete mailTemplatesList[id]
        dispatch(updateMailTemplates({ ...mailTemplatesList }))
        dispatch(updateNotification({ type: 'is-success', message: t('messages.removed_successfuly', { title: mailTemplate.name }) }))
      } else {
        dispatch(updateNotification({ type: 'is-danger', message: t('messages.error_occured') }))
      }
    })
  }

  useEffect(() => {
    get(`${import.meta.env.VITE_API_URL}/api/missions/${mission.id}/mail-templates`, response => {
      const { code, mailTemplates, mailTemplateTypes } = response
      if (200 === code) {
        dispatch(fullUpdate({ mailTemplates, mailTemplateTypes }))
      }
    })
  }, [])

  return (
    <Div cssClass='users-list'>
      <Div cssClass='actions-zone'>
        <Buttons buttons={{
          icon: 'icon-add',
          cssClass: 'is-info is-small',
          callback: () => toggleDynamicForm('mailTemplate'),
          text: t('actions.add')
        }}
        />
      </Div>
      <h2 className='zone-title'>{t('titles.mail_templates_list')}</h2>
      {null !== mailTemplates && dataMailTemplates.nodes.length
        ? <>
          <Table data={dataMailTemplates} theme={theme}>
            {(tableList) => (
              <>
                <Header>
                  <HeaderRow>
                    <HeaderCell>ID</HeaderCell>
                    <HeaderCell>{t('table.Type')}</HeaderCell>
                    <HeaderCell>{t('table.Language')}</HeaderCell>
                    <HeaderCell>{t('table.UpdatedAt')}</HeaderCell>
                    <HeaderCell>{t('table.IsActive')}</HeaderCell>
                    <HeaderCell>Actions</HeaderCell>
                  </HeaderRow>
                </Header>
                <Body>
                  {tableList.map(item =>
                    <Row key={item.id} item={item}>
                      <Cell>{item.id}</Cell>
                      <Cell>{t(`content.${item.type}`)}</Cell>
                      <Cell>{item.language}</Cell>
                      <Cell>{item.updatedAt}</Cell>
                      <Cell>{item.isActive ? t('labels.yes') : t('labels.no')}</Cell>
                      <Cell className='table-actions'>
                        <Buttons buttons={[
                          {
                            icon: 'icon-create',
                            cssClass: 'is-info is-small',
                            callback: () => toggleDynamicForm('mailTemplate', null, item)
                          }
                        ]} />
                        {deleteButton(item, item.title, removeTemplate)}
                      </Cell>
                    </Row>
                  )}
                </Body>
              </>
            )}
          </Table>
        </>
        : <Alert type='is-info' message={t('messages.empty_list')} />
      }
    </Div>
  )
}

export default ListMailTemplates